import { Link, Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-patriotic-gradient-subtle flex flex-col">
      {/* Simple header with logo */}
      <header className="p-4 md:p-6">
        <Link to="/" className="inline-flex items-center gap-2 group">
          <div className="bg-patriotic-gradient p-2 rounded-lg">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <span className="text-xl font-bold font-serif text-neutral-900 group-hover:text-primary-600 transition-colors">
            VotePlan
          </span>
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <Outlet />
      </main>

      {/* Simple footer */}
      <footer className="p-4 md:p-6 text-center text-sm text-neutral-600">
        <p>
          By continuing, you agree to our{' '}
          <Link to="/terms" className="text-primary-600 hover:text-primary-700">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link to="/privacy" className="text-primary-600 hover:text-primary-700">
            Privacy Policy
          </Link>
        </p>
      </footer>
    </div>
  );
}
